module.exports = __webpack_public_path__ + "img/icon_c++.cd66527e.png";